import { createQueryKeys } from '@lukemorales/query-key-factory';

export const roleCategoriesKeys = createQueryKeys('roleCategories', {
  list: () => ({}),
});
